<template>
	<div>
		<v-select
			background-color="white"
			outline
			class="body-1"
			:height="8"
			hide-details
			v-model="level"
			item-text="level"
			item-value="level"
			:items="levels"
			:return-object="false"
			label="Niveles"
			@input="$emit('on-filter', $event)"
		></v-select>
	</div>
</template>

<script>
	function data() {
		return {
			level: null,
		};
	}

	export default {
		name: 'accounting-account-filter',
		data,
		props: {
			levels: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/accounting-accounts/accounting-account-filter.vue